import { subMinutes } from 'date-fns/esm';
import parseISO from 'date-fns/parseISO';

import * as AuthenticationConstants from './constants';

/**
 *
 * @param {Number} expirationDate ISO string
 */
const authenticationIsExpired = (expirationDate) => {
    if (!expirationDate) {
        return true;
    }

    return new Date() > subMinutes(parseISO(expirationDate), 10);
};

const isLoginMethodUsername = (method) => method === AuthenticationConstants.LOGIN_METHOD_USERNAME;

const isLoginMethodProfileTemp = (method) => method === AuthenticationConstants.LOGIN_METHOD_PROFILE_TEMP;

export const getAuthorizationName = (authenticationState) => {
    switch (authenticationState.loginMethod) {
        case AuthenticationConstants.LOGIN_METHOD_USERNAME:
            return 'Bearer';
        case AuthenticationConstants.LOGIN_METHOD_PROFILE_TEMP:
            return 'X-Device-Id';
        default:
            return '';
    }
};

export const getAuthorizationValue = (authenticationState) => {
    switch (authenticationState.loginMethod) {
        case AuthenticationConstants.LOGIN_METHOD_USERNAME:
            return authenticationState.access_token;
        case AuthenticationConstants.LOGIN_METHOD_PROFILE_TEMP:
            return authenticationState.xDeviceId;
        default:
            return '';
    }
};

export { authenticationIsExpired, isLoginMethodUsername, isLoginMethodProfileTemp };
